var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 522.76 103.81",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 103.81)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3703.2 0.0039062h-1629.7c-62.43 0-109.16 57.254-96.66 118.42l118.88 581.27c9.38 45.918 49.78 78.891 96.65 78.891h1629.7c62.43 0 109.16-57.254 96.65-118.42l-118.87-581.27c-9.38-45.918-49.79-78.887-96.65-78.887",
    fill: "#f47818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2495.3 125.72h-347.58l112.18 526.89h116.12l-92.42-434.47h231.45l-19.75-92.422",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2664.4 125.72h-116.91l112.16 526.89h116.92l-112.17-526.89",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3030.2 125.72h-136.66l-78.99 526.89h121.65l48.98-414.73 223.56 414.73h122.44l-300.98-526.89",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3704.8 572.82h-224.35l-30.8-139.82h214.87l-17.39-78.992h-213.28l-32.39-148.51h232.25l-17.38-79.785h-347.57l112.16 526.89h341.26l-17.38-79.785",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1694.3 637.51c7.07 9.082 18.2 15.355 28.83 15.355h174.44l-360.2-527.15h-193.28l-79.06 430.46-183.41-166.91 183.41-263.54h-219.62l-156.09 238.42-4.051 7.64-68.242-246.06h-208.76l46.453 153.53c4.309 7.715 9.539 26.938 12.98 36.852l-2.949-2.649c-62.121-102.52-177.5-178.79-290.47-187.05l-12.867-0.683h-361.41s166.57 499.69 166.76 500.37c4.539 14.684 20.011 26.781 34.773 26.781h313.81c116.67-0.297 192.19-75.734 195.02-180.3l-0.035-11.653c2.305 7.113 7.828 20.957 9.801 34.274l34.422 126.13 1.441 4.847c4.5 14.68 20.086 26.703 34.801 26.703l181.25-0.074-67.227-214.96 8.66 7.27 216.97 194.3c3.06 3.032 6.51 5.75 10.18 7.872 5.59 3.48 11.91 5.593 18.08 5.593h273.26l50.73-308.93c0.99-8.93 2.94-19.524 2.94-19.524 5.26 12.789 9.09 16.192 12.3 20.813l192.75 287.67c1.14 1.664 2.35 3.179 3.6 4.617m-1449.4-406.46 62.16 0.527c89.277 0.832 183.36 73.242 210.6 162.53 27.465 89.734-23.043 162.75-113.65 162.67h-51.941l-107.18-325.73",
    fill: "#767a7c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4801968bb3eef5a116343cd29cf20e31.svg";
export { ForwardRef as ReactComponent };